import { Injectable } from '@angular/core';
import { ToastType } from './toast-type.enum';
import { BehaviorSubject, Observable } from 'rxjs';
import { Toast } from './toast.model';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class ToastService {
	private _timer: any;
	private _toast$: BehaviorSubject<Toast> = new BehaviorSubject<Toast>({ info: null, message: null, show: false, type: null });

	get toast$(): Observable<Toast> {
		return this._toast$.asObservable();
	}

	serverError(res: HttpErrorResponse, message?: string) {
		if (!message) {
			if (res?.status === 401) {
				message = 'Je hebt geen toegang om deze actie uit te voeren!';
			} else {
				message = 'Er liep iets mis!';
			}
		}

		const info = res?.error?.message || res?.error?.statusCode || res?.message;

		this.show(ToastType.ERROR, message, info);
	}

	show(type: ToastType, message: string, info: string | null = null) {
		if (this._timer) {
			clearTimeout(this._timer);
		}

		this._toast$.next({
			info,
			message,
			type,
			show: true,
		});

		const time = type === ToastType.SUCCESS ? 4_000 : 8_000;
		this._timer = setTimeout(() => this.clear(), time);
	}

	clear() {
		if (this._timer) {
			clearTimeout(this._timer);
		}

		if (this._toast$.value.message) {
			this._timer = setTimeout(() => {
				this._toast$.next({
					...this._toast$.value,
					message: null,
					info: null,
				});
			}, 400);
		}

		this._toast$.next({
			...this._toast$.value,
			show: false,
		});
	}
}
